import React, { useContext, useMemo, useState } from 'react';
import classname from 'classnames';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { useCtrLogger } from '@bingads-webui-campaign/reports-v4-telemetry';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Button, Glyphicon } from '@bingads-webui-react/primitive';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getInsertionOrderSelectorStyle } from '../styles';
import { getSelectorButtonDescription } from '../utils';
import { InsertionOrderSelectorCallout } from './insertion-order-selector-callout';

export function InsertionOrderSelector({
  selectedInsertionOrders,
  updateSelectedInsertionOrder,
}) {
  const [isCalloutVisible, setIsCalloutVisible] = useState(false);
  const classes = useDefaultStyles(getInsertionOrderSelectorStyle);
  const i18n = useContext(I18nContext);
  const ctrLogger = useCtrLogger('ReportsV4PreviewReport');
  const buttonDescription = useMemo(() => getSelectorButtonDescription({ i18n, selectedInsertionOrders }), [selectedInsertionOrders, i18n]);

  const handleApply = (selected) => {
    setIsCalloutVisible(!isCalloutVisible);
    updateSelectedInsertionOrder(selected);
  };

  const onSelectorButtonClick = () => {
    ctrLogger.click({ target: 'insertionOrderSelectorButton', extraData: { reportType: 'InsertionOrderReport', oldCalloutVisible: isCalloutVisible, newCalloutVisible: !isCalloutVisible } });
    setIsCalloutVisible(!isCalloutVisible);
  };

  return (
    <React.Fragment>
      <Button
        onClick={onSelectorButtonClick}
        className={classname('insertion-order-selector-button', classes.SelectorButton)}
      >
        <span className={classname('insertion-order-selector-button', classes.ButtonDescription)}>
          {buttonDescription}
        </span>
        <Glyphicon className={classes.ChevronDownIcon} glyph="ba-ChevronDown" />
      </Button>
      {isCalloutVisible &&
        <InsertionOrderSelectorCallout
          target=".insertion-order-selector-button"
          initialSelectedItems={selectedInsertionOrders}
          onApply={handleApply}
          onDismiss={() => { setIsCalloutVisible(false); }}
        />
      }
    </React.Fragment>
  );
}

InsertionOrderSelector.propTypes = {
  selectedInsertionOrders: PropTypes.arrayOf(PropTypes.shape({})),
  updateSelectedInsertionOrder: PropTypes.func,
};

InsertionOrderSelector.defaultProps = {
  selectedInsertionOrders: [],
  updateSelectedInsertionOrder: _.noop,
};
